import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSplitIconLargeActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100}
    height={56.25}
    data-name="Group 52"
    {...props}
  >
    <g data-name="White Box">
      <path fill="#fff" d="M99.5 55.75H.5V.5h99Z" data-name="Path 1" />
      <path
        fill="#024"
        d="M1 1v54.25h98V1zM0 0h100v56.25H0Z"
        data-name="Path 2"
      />
    </g>
    <path fill="#024" d="M3 3h70.6v49.25H3Z" data-name="Grey Box" />
    <path
      fill="#024"
      d="M75.6 20.13h21.335v14.989H75.6Z"
      data-name="Grey Box-2"
    />
  </svg>
);
export default SvgSplitIconLargeActive;
